import React, { useState } from 'react';

const Editor = ({ values, onChange }) => {
  const [input, setInput] = useState('');

  const handleAdd = () => {
    const val = input.trim();
    if (!val) return;
    if (values.includes(val)) {
      setInput('');
      return;
    }
    onChange([...values, val]);
    setInput('');
  };

  const handleRemove = (idx) => {
    const next = values.filter((_, i) => i !== idx);
    onChange(next);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <div style={{ display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    width: '50%' }}>
        <input
          type="text"
          value={input}
          placeholder="value"
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          style={{
            padding: '6px 8px',
            fontSize: '16px',
            flexGrow: 1,
            borderRadius: '4px',
            border: '1px solid #ccc',
          }}
        />
        <button
          type="button"
          onClick={handleAdd}
          style={{
            padding: '6px 10px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            cursor: 'pointer',
            backgroundColor: '#f3f3f3',
          }}
        >
          Add
        </button>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
        {values.map((val, i) => (
          <div
            key={i}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              padding: '4px 8px',
              borderRadius: '12px',
              backgroundColor: '#eee',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'black',
            }}>
            <span>{val}</span>
            <button
              type="button"
              onClick={() => handleRemove(i)}
              style={{
                marginLeft: '6px',
                border: 'none',
                background: 'transparent',
                cursor: 'pointer',
                fontSize: '14px',
                lineHeight: 1,
              }}
              aria-label={`Remove ${val}`}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Editor;
